import { useState } from 'react';
import { faqs } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            毒蘑菇测试常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于毒蘑菇鉴别的热门问题，这里都有权威解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-2">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}